import React from 'react'

export default class extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (<div>Menu Recherche</div>)
  }
}




// WEBPACK FOOTER //
// ./app/App/Module/Menu/Page/Recherche/index.js